"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ERP", {
  enumerable: true,
  get: function get() {
    return _Category.ERP;
  }
});
Object.defineProperty(exports, "IPAAS", {
  enumerable: true,
  get: function get() {
    return _Category.IPAAS;
  }
});
Object.defineProperty(exports, "PROJECT", {
  enumerable: true,
  get: function get() {
    return _Category.PROJECT;
  }
});
Object.defineProperty(exports, "WORKFLOW", {
  enumerable: true,
  get: function get() {
    return _Category.WORKFLOW;
  }
});

var _Category = require("../Category");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/superCategoryGroups/Productivity.js
// module id = 594
// module chunks = 209 210 211 212 213